import React, { createContext, useContext, useEffect, useState } from "react"; // Import React and hooks
import { Urls } from "./Urls"; // Import URLs from Urls file
import { auth } from "./Components/firebase/firebase"; // Import auth object from Firebase setup
import Axios from "./Axios"; // Import Axios instance

// Create a context for user data
export const UserDataContext = createContext({});

// Provider component to manage and provide user data
export const UserDataProvider = ({ children }) => {
  const [userData, setUserData] = useState({}); // State to store user data
  const [companyName, setCompanyName] = useState(""); // Derived display company name (with email-domain fallback)

  const fetchUserData = () => {
    Axios.get(Urls.user_data) // Make GET request to fetch user data
      .then((res) => {
        setCompanyName(
          res.data.company_name
            ? res.data.company_name
            : res.data.email
            ? res.data.email.split("@")[1].split(".")[0]
            : ""
        );
        setUserData(res.data);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    // Fetch user data when component mounts
    if (auth && auth.currentUser && auth.currentUser.getIdToken()) {
      // Handle errors
      fetchUserData();
    }
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <UserDataContext.Provider value={[userData, setUserData, fetchUserData, companyName]}>
      {children} {/* Render child components with user data context */}
    </UserDataContext.Provider>
  );
};

// Custom hook to use user data context
export function useUser() {
  return useContext(UserDataContext);
}
